import { Market } from "@abios/abios-ts-sdk"
import { MARKET_TYPE_PRIORITY } from "./MarketTypePriority"

export const orderMarkets = (markets: Market[]) =>
  markets.sort(
    (firstMarket, secondMarket) =>
      MARKET_TYPE_PRIORITY[firstMarket.type] -
      MARKET_TYPE_PRIORITY[secondMarket.type],
  )
